export const DownloadNarrowIcon = ({ color = "#FFFFFF", size = 9, ...props }) => (
    <svg width={size} height={size * (14 / 9)} viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M9 4.58824H6V2.29412V0H3V2.29412V4.58824H0L4.5 9.94118L9 4.58824ZM0 11.4706V13L9 13.0294V12.2647V11.5L0 11.4706Z" fill={color} />
    </svg>
);
